import { FunctionComponent } from 'react';

import { Container } from './style';

const StyledContainer: FunctionComponent<any> = ({ children }) => {
  return <Container>{children}</Container>;
};

export default StyledContainer;
